export const PROGRESS_BAR_DEFAULT_SIZE = "medium"